import "./sp-action-button-CjSKZ-qO.js";
import { O as p } from "./observe-slot-presence-BhCYOJih.js";
import { O as u } from "./observe-slot-text-DWmBsDhw.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-more.js";
import { i as b, x as i } from "./lit-element-6iugfgmM.js";
import { S as m } from "./slottable-request-event-B1mW6PN4.js";
import { D as y, a as f } from "./Picker-Cpjx4vH1.js";
import { o as c } from "./if-defined-D-RhGngI.js";
import { n as h } from "./property-BWlAHqg_.js";
import { t as g } from "./state-STZTbIJp.js";
import { d as v } from "./define-element-Dl91r6Vu.js";
const $ = b`
    :host{display:inline-flex}:host([quiet]){min-width:0}:host>sp-menu{display:none}::slotted([slot=icon]){flex-shrink:0}.icon{flex-shrink:0}#popover{max-width:none}:host([dir=ltr]) ::slotted([slot=icon]),:host([dir=ltr]) .icon{margin-left:calc(-1*(var(--spectrum-actionbutton-textonly-padding-left-adjusted) - var(--spectrum-actionbutton-padding-left-adjusted)))}:host([dir=rtl]) ::slotted([slot=icon]),:host([dir=rtl]) .icon{margin-right:calc(-1*(var(--spectrum-actionbutton-textonly-padding-left-adjusted) - var(--spectrum-actionbutton-padding-left-adjusted)))}:host([dir]) slot[icon-only]::slotted([slot=icon]),:host([dir]) slot[icon-only] .icon{margin-inline:calc((var(--custom-actionbutton-edge-to-text,var(--spectrum-actionbutton-edge-to-text)) - var(--custom-actionbutton-edge-to-visual-only,var(--spectrum-actionbutton-edge-to-visual-only)))*-1)}sp-overlay:not(:defined){display:none}
`;
var w = Object.defineProperty, x = Object.getOwnPropertyDescriptor, d = (l, t, a, o) => {
  for (var n, e = o > 1 ? void 0 : o ? x(t, a) : t, r = l.length - 1; r >= 0; r--) (n = l[r]) && (e = (o ? n(t, a, e) : n(e)) || e);
  return o && e && w(t, a, e), e;
};
class s extends p(u(f, "label"), '[slot="label-only"]') {
  constructor() {
    super(...arguments), this.selects = void 0, this.listRole = "menu", this.itemRole = "menuitem", this.handleSlottableRequest = (t) => {
      this.dispatchEvent(new m(t.name, t.data));
    };
  }
  static get styles() {
    return [$];
  }
  get hasLabel() {
    return this.slotHasContent;
  }
  get labelOnly() {
    return this.slotContentIsPresent;
  }
  get buttonContent() {
    return [i`
                ${this.labelOnly ? i`` : i`
                          <slot
                              name="icon"
                              slot="icon"
                              ?icon-only=${!this.hasLabel}
                              ?hidden=${this.labelOnly}
                          >
                              <sp-icon-more
                                  class="icon"
                                  size=${this.size}
                              ></sp-icon-more>
                          </slot>
                      `}
                <slot name="label" ?hidden=${!this.hasLabel}></slot>
                <slot name="label-only"></slot>
            `];
  }
  render() {
    return this.tooltipEl && (this.tooltipEl.disabled = this.open), i`
            <sp-action-button
                aria-describedby=${y}
                ?quiet=${this.quiet}
                ?selected=${this.open}
                static-color=${c(this.staticColor)}
                aria-haspopup="true"
                aria-controls=${c(this.open ? "menu" : void 0)}
                aria-expanded=${this.open ? "true" : "false"}
                aria-label=${c(this.label || void 0)}
                id="button"
                class="button"
                size=${this.size}
                @blur=${this.handleButtonBlur}
                @focus=${this.handleButtonFocus}
                @keydown=${{ handleEvent: this.handleEnterKeydown, capture: !0 }}
                ?disabled=${this.disabled}
            >
                ${this.buttonContent}
            </sp-action-button>
            <slot
                name="tooltip"
                @slotchange=${this.handleTooltipSlotchange}
            ></slot>
            ${this.renderMenu} ${this.renderDescriptionSlot}
        `;
  }
  update(t) {
    t.has("invalid") && (this.invalid = !1), super.update(t);
  }
  hasAccessibleLabel() {
    return !!this.label || !!this.getAttribute("aria-label") || !!this.getAttribute("aria-labelledby") || !!this.appliedLabel || this.hasLabel || this.labelOnly;
  }
  warnNoLabel() {
    window.__swc.warn(this, `<${this.localName}> needs one of the following to be accessible:`, "https://opensource.adobe.com/spectrum-web-components/components/action-menu/#accessibility", { type: "accessibility", issues: [`an <sp-field-label> element with a \`for\` attribute referencing the \`id\` of the \`<${this.localName}>\`, or`, 'value supplied to the "label" attribute, which will be displayed visually as placeholder text', 'text content supplied in a <span> with slot="label", or, text content supplied in a <span> with slot="label-only"', "which will also be displayed visually as placeholder text."] });
  }
}
d([h({ type: String })], s.prototype, "selects", 2), d([h({ reflect: !0, attribute: "static-color" })], s.prototype, "staticColor", 2), d([g()], s.prototype, "labelOnly", 1), v("sp-action-menu", s);
//# sourceMappingURL=sp-action-menu-BRPv82Nv.js.map
